/* @ngInject */
function CampaignUpdateDialogController ($scope, $rootScope, $translate, CampaignService, ToastService, $timeout) {
  $scope.campaign = $scope.data.campaign
  $scope.updatedCampaign = { ...($scope.data.campaign ?? {}) }
  $scope.minDeliveryDate = $scope.data.campaign.status === 'IN_PROGRESS' ? new Date($scope.data.campaign.deliveryDate) : $scope.data.campaign.startDate
  $scope.flags = {
    loading: false,
    fields: {
      title: {
        error: false,
        changed: false
      },
      startDate: {
        error: false,
        changed: false
      },
      deliveryDate: {
        error: false,
        changed: false
      },
      expireCampaignContentsOnFinish: {
        error: false,
        changed: false
      }
    },
    buttons: {
      save: {
        disabled: true
      }
    }
  }

  const api = {
    _onChangeTitle,
    _onChangeStartDate,
    _onChangeDeliveryDate,
    _onChangeExpireContentOnCampaignFinish,
    _validateFields
  }
  this.getApi = () => api

  activate()
  function activate () {}

  $scope.onChangeTitle = (event) => {
    api._onChangeTitle(event)
  }

  $scope.onChangeStartDate = (event) => {
    api._onChangeStartDate(event)
  }

  $scope.onChangeDeliveryDate = (event) => {
    api._onChangeDeliveryDate(event)
  }

  $scope.onChangeExpireContentOnCampaignFinish = (event) => {
    api._onChangeExpireContentOnCampaignFinish(event)
  }

  $scope.confirmAction = () => {
    $scope.flags.loading = true
    CampaignService.updateCampaign($scope.campaign.id, {
      title: $scope.updatedCampaign.title,
      startDate: $scope.updatedCampaign.startDate,
      deliveryDate: $scope.updatedCampaign.deliveryDate,
      expireCampaignContentsOnFinish: $scope.updatedCampaign.expireCampaignContentsOnFinish
    })
      .then(() => {
        ToastService.defaultSuccessToast()
        $scope.flags.loading = false
        $scope.close($scope.updatedCampaign)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      }).finally(() => {
        $scope.flags.loading = false
      })
  }

  $scope.closeModal = (returnData) => {
    $scope.close(returnData)
  }

  function _onChangeTitle (event) {
    $scope.updatedCampaign.title = event?.detail?.value
    api._validateFields()
  }

  function _onChangeStartDate (event) {
    if ($scope.campaign.status !== 'WAITING') return
    $scope.updatedCampaign.startDate = event?.detail?.date
    api._validateFields()
  }

  function _onChangeDeliveryDate (event) {
    if ($scope.campaign.status === 'FINISHED') return
    $scope.updatedCampaign.deliveryDate = event?.detail?.date
    api._validateFields()
  }

  function _onChangeExpireContentOnCampaignFinish (event) {
    $scope.updatedCampaign.expireCampaignContentsOnFinish = event?.detail?.value ?? false
    api._validateFields()
  }

  function _validateFields () {
    const updatedTitle = ($scope.updatedCampaign.title || '')
    const originalTitle = ($scope.campaign.title || '')

    const updatedStartDate = $scope.updatedCampaign.startDate
    const originalStartDate = $scope.campaign.startDate

    const updatedDeliveryDate = $scope.updatedCampaign.deliveryDate
    const originalDeliveryDate = $scope.campaign.deliveryDate

    const updatedExpireCampaignContentsOnFinish = $scope.updatedCampaign.expireCampaignContentsOnFinish
    const originalExpireCampaignContentsOnFinish = $scope.campaign.expireCampaignContentsOnFinish

    const nextFlags = {
      ...$scope.flags,
      fields: {
        title: {
          changed: updatedTitle !== originalTitle,
          error: updatedTitle.length === 0
        },
        startDate: {
          changed: updatedStartDate !== originalStartDate,
          error: !isValidDate(updatedStartDate)
        },
        deliveryDate: {
          changed: updatedDeliveryDate !== originalDeliveryDate,
          error: !isValidDate(updatedDeliveryDate)
        },
        expireCampaignContentsOnFinish: {
          changed: updatedExpireCampaignContentsOnFinish !== originalExpireCampaignContentsOnFinish,
          error: false
        }
      }
    }

    const hasError = nextFlags.fields.title.error || nextFlags.fields.startDate.error || nextFlags.fields.deliveryDate.error || nextFlags.fields.expireCampaignContentsOnFinish.error
    const hasChanges = nextFlags.fields.title.changed || nextFlags.fields.startDate.changed || nextFlags.fields.deliveryDate.changed || nextFlags.fields.expireCampaignContentsOnFinish.changed

    nextFlags.buttons = { ...nextFlags.buttons, save: { disabled: hasError || !hasChanges } }

    $scope.$applyAsync(() => {
      $scope.flags = nextFlags
    })
  }

  function isValidDate (value) {
    if (!value) return false
    const date = new Date(value)
    return !isNaN(date.getTime())
  }
}

export { CampaignUpdateDialogController }
